<template>
  <fetch-artwork-list :query="query" :api="api">
    <template v-slot:default="{ state, artworks, pagination, sync }">
      <div>
        <div class="container px-18">
          <the-exhibit-sets/>
        </div>

        <the-filter-panel-mobile></the-filter-panel-mobile>

        <div class="pb-16 mb-20 shadow-md">
          <mobile-artwork-filter></mobile-artwork-filter>
        </div>
        <selected-filter-panel class="container px-20 mb-36"></selected-filter-panel>
        <div class="container flex lg:px-20">
          <artwork-grid-loader :state="state">
            <div v-if="page.startsWith('/artists/')" class="px-20 mb-12">
              <h2 class="text-dark-gray text-16 md:text-18">
                All Artworks By <span class="text-black">"{{ artistName }}"</span>
              </h2>
            </div>

            <div v-else class="px-20 mb-12">
              <h1 v-if="query.search" class="text-dark-gray text-16 md:text-18">
                Artworks with <span class="text-black">"{{ query.search }}"</span>
              </h1>
              <h1 v-else class="text-dark-gray text-16 md:text-18">
                All Artworks
              </h1>
            </div>
            <artwork-grid :artworks="artworks">
              <template v-slot:default="{ artwork }">
                <artwork-card
                  class="mb-30 lg:mb-56"
                  :artwork="artwork"
                  @update:artwork="sync(artwork, $event)">
                </artwork-card>
              </template>
            </artwork-grid>
          </artwork-grid-loader>
        </div>
        <artwork-pagination
          v-if="state === 'loaded'"
          :pagination="pagination"
          @navigated="$listeners.navigated">
        </artwork-pagination>

        <the-gallery-mobile-exhibit-grid/>
      </div>
    </template>
  </fetch-artwork-list>
</template>

<script>
import ArtworkGrid from '../../Universal/ArtworkGrid.vue'
import ArtworkGridLoader from '../../ArtworkGridLoader.vue'
import MobileArtworkFilter from '../../MobileArtworkFilter.vue'
import PaginationProgress from '../../PaginationProgress.vue'
import SelectedFilterPanel from '../../SelectedFilterPanel.vue'
import ArtworkPagination from '../../ArtworkPagination.vue'
import ArtworkCard from '../../Universal/GridLoader/Cards/ArtworkCard.vue'
import FetchArtworkList from '../../FetchArtworkList.vue'
import TheFilterPanelMobile from "../../TheFilterPanelMobile.vue";
import TheExhibitSets from "./TheExhibitSets.vue";
import TheOngoingExhibitPanel from './TheOngoingExhibitPanel.vue'
import GroupSwiperCarousel from '../../Universal/Carousel/GroupSwiperCarousel.vue';
import TheGalleryMobileExhibitGrid from "./TheGalleryMobileExhibitGrid.vue";

export default {
  components: {
    TheGalleryMobileExhibitGrid,
    TheExhibitSets,
    TheFilterPanelMobile,
    ArtworkGrid,
    ArtworkGridLoader,
    MobileArtworkFilter,
    PaginationProgress,
    SelectedFilterPanel,
    ArtworkPagination,
    ArtworkCard,
    FetchArtworkList,
    TheOngoingExhibitPanel,
    GroupSwiperCarousel
  },

  data() {
    return{
      isLoading: true,
    }
  },

  inject: {
    query: 'query',
    api: 'api',
  },

  computed: {
    page () {
      return window.location.pathname
    },

    artistName () {
      return window.slugToHumanString(this.query.artist)
    }
  },
}
</script>
